module.exports = __webpack_public_path__ + "img/zp.5784fde7.jpg";